import {useEffect, useRef, useState} from 'react'
import {CompaniesWithPersonalizedDashboards} from 'src/hooks/usePersonalizedThemeByCompany'
import {objectTypeList} from 'src/pages/alarms/AlarmsFunctions'
import {Alarm} from 'src/services/api'

type Props = {
  allEvents: Alarm[]
}

export default function useNotificationPopUp(props: Props) {
  const {allEvents} = props
  const lastNotificationTime = useRef(0)
  const lastIdEventOnNotification = useRef(0)
  const [isTabVisible, setIsTabVisible] = useState(!document.hidden)

  useEffect(() => {
    function handleVisibilityChange() {
      setIsTabVisible(!document.hidden)
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  function sendNotification(events: Alarm[]) {
    const url = window.location.href
    if (Notification.permission !== 'granted' || !events.length) return

    const now = Date.now()
    const COOLDOWN_10_SECONDS = 10 * 1000

    if (now - lastNotificationTime.current < COOLDOWN_10_SECONDS) return
    lastNotificationTime.current = now

    const event = events[0]
    if (!event) return

    if (event.id === lastIdEventOnNotification.current) return
    lastIdEventOnNotification.current = event.id

    if (isTabVisible) return

    const listOfObjects = event.objects?.split(',')
    const translateObjects = objectTypeList.filter((object) => listOfObjects?.includes(object.name)).map((it) => it.label)

    const objectName = translateObjects.join(', ')
    const createdAt = new Date(event.createdAt)
    const time = createdAt.toLocaleString()

    let icon = process.env.PUBLIC_URL + '/icon.svg'
    if (CompaniesWithPersonalizedDashboards.some((companyUrl) => url.includes(companyUrl))) icon = process.env.PUBLIC_URL + '/sekronIcon.svg'

    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(`📢  Detecção de ${objectName}`, {
        body: `Detecção de ${objectName} na câmera: ${event.camera.name}\nHorário: ${time}\n, Id do Evento: ${event.id}`,
        icon,
        data: {
          eventId: event.id,
        },
      })
    })
  }

  useEffect(() => {
    if (allEvents.length) sendNotification(allEvents)
  }, [allEvents])
}
